import { ForYourVehicleProp } from '../models/sectionForYourVehicle'

import imageCard1 from '../assets/combustivel.png'
import imageCard2 from '../assets/oleos-lubrificantes.png'
import imageCard3 from '../assets/shell-recharge.png'

export const getForYourVehicle = async (): Promise<ForYourVehicleProp> => {
  return Promise.resolve([
      {
        title: "Para o seu Veículo",
        description: "Tecnologias e serviços da Shell que ajudam no cuidado, no desempenho e na eficiência do seu veículo, em diferentes tipos de uso e trajetos.",
        solutions: [
            {
                id: '1',
                model: '',
                title: 'Combustíveis',
                text: '<strong>Os combustíveis Shell oferecem tecnologias que contribuem para eficiência, proteção do motor e melhor desempenho</strong> em diferentes tipos de uso.',
                image: imageCard1,
                actions: [
                    {
                        title: 'Conheça nossos combustíveis',
                        url: 'https://www.shell.com.br/motoristas/combustiveis.html?utm_source=promoshell&utm_medium=conheca-nossos-combustiveis&utm_id=home'
                    }
                ]
            },{
                id: '2',
                model: '',
                title: 'Óleos lubrificantes',
                text: '<strong>Os óleos lubrificantes Shell ajudam a proteger o motor, manter o desempenho e garantir eficiência</strong> no uso diário ou em trajetos mais longos.',
                image: imageCard2,
                actions: [
                    {
                        title: 'Encontre o lubrificante ideal',
                        url: 'https://www.shell.com.br/motoristas/oleos-e-lubrificantes/lubematch?utm_source=promoshell&utm_medium=encontre-o-lubrificante-ideal&utm_id=home'
                    }
                ]
            },{
                id: '3',
                model: '',
                title: 'Shell Recharge',
                text: '<strong>Com o Shell Recharge você encontra pontos de recarga para veículos elétricos,</strong> com praticidade, segurança e suporte na sua mobilidade diária.',
                image: imageCard3,
                actions: [
                    {
                        title: 'Conheça Shell Recharge',
                        url: 'https://www.shell.com.br/motoristas/shell-recharge?utm_source=promoshell&utm_medium=conheca-shell-recharge&utm_id=home'
                    }
                ]
            }
        ]
    }
  ])
}